import React from 'react';
import PropTypes from 'prop-types';

import { Avatar } from '@mui/material';

import stringAvatar from '../../../../main-deprecated/components/NavigationBar/SubComponents/stringAvatar';

const UserDetailAvatar = ({ user, size = 180 }) => (
  <Avatar
    {...stringAvatar(user)}
    src={user?.profilePictureUrl || undefined}
    alt={user?.name || ''}
    data-testid="user-detail-avatar"
    sx={{ width: size, height: size }}
  />
);

UserDetailAvatar.propTypes = {
  user: PropTypes.shape({
    id: PropTypes.string,
    name: PropTypes.string,
    profilePictureUrl: PropTypes.string,
  }),
  size: PropTypes.number,
};

export default UserDetailAvatar;
